var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6065 6.51118C13.8888 6.20807 13.872 5.7335 13.5689 5.45118C13.2657 5.16887 12.7912 5.18572 12.5089 5.48882L13.6065 6.51118ZM5.05751 13.4888C4.77519 13.7919 4.79204 14.2665 5.09514 14.5488C5.39825 14.8311 5.87282 14.8143 6.15514 14.5112L5.05751 13.4888ZM6.15514 5.48882C5.87283 5.18572 5.39825 5.16887 5.09515 5.45118C4.79205 5.7335 4.7752 6.20808 5.05751 6.51118L6.15514 5.48882ZM12.5089 14.5112C12.7912 14.8143 13.2658 14.8311 13.5689 14.5488C13.872 14.2665 13.8888 13.7919 13.6065 13.4888L12.5089 14.5112ZM12.5089 5.48882L5.05751 13.4888L6.15514 14.5112L13.6065 6.51118L12.5089 5.48882ZM5.05751 6.51118L12.5089 14.5112L13.6065 13.4888L6.15514 5.48882L5.05751 6.51118ZM16.9648 10C16.9648 14.6074 13.4982 18.25 9.332 18.25V19.75C14.4252 19.75 18.4648 15.3337 18.4648 10H16.9648ZM9.332 18.25C5.16582 18.25 1.69922 14.6074 1.69922 10H0.199219C0.199219 15.3337 4.23881 19.75 9.332 19.75V18.25ZM1.69922 10C1.69922 5.39258 5.16582 1.75 9.332 1.75V0.25C4.23881 0.25 0.199219 4.6663 0.199219 10H1.69922ZM9.332 1.75C13.4982 1.75 16.9648 5.39258 16.9648 10H18.4648C18.4648 4.6663 14.4252 0.25 9.332 0.25V1.75Z",
    fill: "#6B6F7B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.83d1f5883044d5514fc6e0b6882f682c.svg";
export { ForwardRef as ReactComponent };